<template>
  <div>
    <div class="frequentlyScannedProductPieChartContainer">
      <div ref="frequentlyScannedProductPieChart" style="width: 100%; height: 350px"></div>
      <div class="labelContainer text-center">
        <h5>{{ labels.value }}%</h5>
        <span>{{ labels.name }}</span>
        <span>{{ labels.partNumber }}</span>
      </div>
    </div>
    <div class="mt-3">
      <div class="row px-4 pb-2" v-for="item in processedData">
        <div class="col-md-10">
          <ul class="list-group list-group-horizontal border-0">
            <li class="list-group-item border-0 p-0 px-1 py-1">
              <span class="badge-part" :style="{ backgroundColor: item.color }">&nbsp;</span>
            </li>
            <li
              class="list-group-item border-0 p-0 px-1 py-1 pt-2 ml-2"
              style="color: #393939; font-family: 'Inter', sans-serif"
            >
              {{ item.name }}
              <br />
              <span style="color: #cecece">{{ item.material_no }}</span>
            </li>
          </ul>
        </div>
        <div class="col-md-2 pt-2 fw-bold text-nowrap text-right">
          <strong>{{ item.percent }} %</strong>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* Imports */
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";

export default {
  data() {
    return {
      chart: null,
      label: null,
      processedData: [],

      dummyData: [
        { kode: "mQ2xoPE1", value: 21000 },
        { kode: "mQ2xoPE2", value: 19000 },
        { kode: "mQ2xoPE3", value: 17000 },
        { kode: "mQ2xoPE4", value: 25000 },
        { kode: "mQ2xoPE5", value: 13000 },
        { kode: "mQ2xoPE6", value: 11000 },
        { kode: "mQ2xoPE7", value: 2000 },
        { kode: "mQ2xoPE8", value: 19000 },
      ],
      labels: {
        value: "0",
        name: "-",
        partNumber: "",
      },
    };
  },
  props: ["data"],
  mounted() {
    this.createChart();
    this.getData();
  },
  watch: {
    data: {
      deep: true,
      handler(newData) {
        this.getData();
      },
    },
  },
  methods: {
    processData(rawData) {
      if (!rawData || rawData.length === 0) {
        return [{ name: "No Data", total: 1 }];
      }

      const total = rawData.reduce((sum, item) => sum + parseInt(item.total), 0);
      const sortedData = [...rawData].sort((a, b) => parseInt(b.total) - parseInt(a.total));
      const top3 = sortedData.slice(0, 3);
      const others = sortedData.slice(3);

      let processed = top3;
      if (others.length > 0) {
        const othersTotal = others.reduce((sum, item) => sum + parseInt(item.total), 0);
        processed = [
          ...top3,
          {
            name: "Others",
            total: othersTotal,
            material_no: "",
            isOthers: true,
          },
        ];
      }

      return processed.map((item, index) => ({
        ...item,
        percent: parseFloat(((parseInt(item.total) / total) * 100).toFixed(1)),
        color: this.getColorByIndex(index),
      }));
    },
    getColorByIndex(index) {
      const colors = ["#3e8df2", "#f2b342", "#ef5265", "#7e71b7"];
      return colors[index % colors.length];
    },
    getData() {
      this.processedData = this.processData(this.data);
      this.chart.data = [];
      this.chart.addData(
        this.processedData.length > 0 ? this.processedData : [{ name: "No Data", total: 1 }]
      );
      console.log("chart data:", this.chart.data);

      if (this.processedData && this.processedData.length > 0) {
        const firstData = this.processedData[0];
        console.log("first data:", firstData);

        const total = this.processedData.reduce((sum, item) => sum + parseInt(item.total), 0);

        this.labels.value = parseFloat(((parseInt(firstData.total) / total) * 100).toFixed(1));
        this.labels.name = firstData.name;
        this.labels.partNumber = firstData.material_no || "";
      } else {
        this.labels.value = 0;
        this.labels.name = "-";
        this.labels.partNumber = "";
      }
    },
    createChart() {
      this.chart = am4core.create(this.$refs.frequentlyScannedProductPieChart, am4charts.PieChart);

      // Set custom color theme
      this.chart.colors.list = [
        am4core.color("#3e8df2"), // Blue
        am4core.color("#f2b342"), // Yellow
        am4core.color("#ef5265"), // Red
        am4core.color("#7e71b7"), // Purple
      ];

      let pieSeries = this.chart.series.push(new am4charts.PieSeries());
      pieSeries.dataFields.value = "total";
      pieSeries.dataFields.category = "name";

      this.chart.innerRadius = am4core.percent(60);

      pieSeries.slices.template.stroke = am4core.color("#fff");
      pieSeries.slices.template.strokeWidth = 2;
      pieSeries.slices.template.strokeOpacity = 1;

      // Disable interactive cursor
      pieSeries.slices.template.cursorOverStyle = [
        {
          property: "cursor",
          value: "default",
        },
      ];

      pieSeries.slices.template.adapter.add("fill", (fill, target) => {
        return this.chart.colors.getIndex(target.dataItem.index);
      });

      pieSeries.slices.template.tooltipHTML = `
        <div>
          <strong>{name}</strong><br>
          {material_no} <br>
          <b>{percent.formatNumber('#.0')}%</b>
          <b>{total} Scanned</b>
        </div>
      `;

      pieSeries.labels.template.disabled = true;
      pieSeries.ticks.template.disabled = true;

      let hoverState = pieSeries.slices.template.states.getKey("hover");
      hoverState.properties.scale = 1;
      hoverState.properties.shiftRadius = 0;

      pieSeries.slices.template.clickable = false;
      pieSeries.slices.template.hoverable = false;
    },
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  },
};
</script>

<style scoped>
.frequentlyScannedProductPieChartContainer {
  position: relative;
}

.labelContainer {
  position: absolute;
  top: 60%;
  left: 50%;
  transform: translate(-50%, -100%);
}

.labelContainer h5 {
  font-size: 20px;
  color: #383838;
}

.labelContainer span {
  display: block;
  font-size: 12px;
  color: #383838;
}

.labelContainer span:last-child {
  color: #cecece;
}

.badge-part {
  display: inline-block;
  padding: 0.35em 0.65em;
  font-size: 0.75em;
  font-weight: 700;
  line-height: 1;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
}
</style>
